import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

const wrapTFnInPrefix =
  (t: TFunction, prefix: string): TFunction =>
  <TResult extends string = string>(key: string | string[], options = {}) =>
    <TResult>t(`${prefix}.${key}`, options);

/**
 * Adds a prefix to each key.
 * @deprecated prefer the useTranslation hook with keyPrefix instead
 * @example
 *
 * useTranslationWithPrefix('namespace:prefix');
 * // becomes
 * useTranslation('namespace', { keyPrefix: 'prefix' });
 *
 * @see {@link https://hotjar.atlassian.net/wiki/spaces/TAME/pages/3298164951/Translations+in+tests+unit+E2E#Unit-tests}
 *
 * @todo The typings are not great and are temporary.
 */
export function useTranslationWithPrefix(prefix: string): {
  t: TFunction;
};

export function useTranslationWithPrefix(prefix: string[]): TFunction[];

export function useTranslationWithPrefix(prefix: string | string[]):
  | {
      t: TFunction;
    }
  | TFunction[] {
  const { t } = useTranslation();

  return typeof prefix === 'string'
    ? {
        t: wrapTFnInPrefix(t, prefix),
      }
    : prefix.map((prefixString) => wrapTFnInPrefix(t, prefixString));
}
